import styled, { ThemedStyledProps } from 'styled-components';
import { TTheme } from '@/styles/Themes/Theme.domain';
import { TTextProps } from './Text.types';
import { fonts } from '@/styles/Themes/Fonts';

export const StyledText = styled.span<ThemedStyledProps<TTextProps, TTheme>>`
    font: ${fonts.normal};
    text-align: 'center';
`;
